export enum ChatType {
  ADMIN_AND_TALENT = 'ADMIN_AND_TALENT',
  ADMIN_AND_FAN = 'ADMIN_AND_FAN',
}
